var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',{attrs:{"title":_vm.$t('pages.chat.title')}}),_c('chat',{attrs:{"conversationData":_vm.conversationData,"userInfo":_vm.userInfo,"chatOnly":false},on:{"sendMessage":function($event){return _vm.message($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }